import React from 'react';

const DistributionBar = ({ label, value, total, color }) => {
  const percentage = total > 0 ? (value / total) * 100 : 0;

  return (
    <div className="mb-3">
      <div className="flex justify-between mb-1 text-sm">
        <span className="font-medium text-gray-700">{label}</span>
        <span className="text-gray-600">
          {percentage.toFixed(1)}% ({value}개)
        </span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-6">
        <div
          className={`${color} h-6 rounded-full flex items-center justify-start px-2 transition-all duration-500`}
          style={{ width: `${percentage}%` }}
        >
          {percentage > 15 && (
            <span className="text-xs font-medium text-white">
              {percentage.toFixed(1)}%
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default DistributionBar;
